module.exports = __webpack_public_path__ + "img/water_sensor.74d40ff0.svg";